import styled from 'styled-components/macro';

export const ScPromoDot = styled.span`
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: ${({ theme }) => theme.pinkRougeGradient};
  flex-shrink: 0;
  pointer-events: none;
`;
